import classNames from 'classnames';
import isFinite from 'lodash/isFinite';
import CSSClasses from './cart.scss';
export const getHeadClasses = itemsCount => isFinite(itemsCount) ? classNames(CSSClasses.cartHead) : '';